import { useState, useEffect } from 'react';
import { getViewPort, listenViewPort } from '../extras/viewPortObserver';

const { desktop } = getViewPort();
export default function useViewport() {
  const [viewport, setViewport] = useState({ desktop });
  useEffect(() => listenViewPort(query => setViewport({ desktop: query.matches })), []);
  return viewport;
}
